<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">

                <funds-form :fund="fund" :loader="loader" @click="storeFund(fund)" :showLabels="false" :showSave="true"></funds-form>

            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import fundsApi from '../../api/funds'
  import fundsForm from './Form.vue'
  import Fund from '../../models/fund'

  export default {

    components: {
      fundsForm
    },
    data () {
      return {
        fund: new Fund(true),
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuovo fondo',
        createButton: {display: false}
      })
      this.$emit('addBackgroundColor', 'rgb(138,163,157)')
    },

    methods: {
      storeFund (fund) {
        this.loader = true
        fund.archive_id = this.$store.state.profile.profile.archive.data.id
        fundsApi.store(fund)
          .then((response) => {
            toastr.success('Il fondo è stato inserito correttamente')
            this.$router.push('/funds')
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/funds/Create.vue